import { type RouteRecordRaw } from 'vue-router';

export const protectedRoutes: RouteRecordRaw[] = [
    {
        path: "/admin/settings",
        component: () => import("./pages/SettingsLayout.vue"),
        meta: { role: "admin", title: "settings.title", requiresAdmin: true },
        children: [
            {
                path: "",
                name: "system-settings",
                component: () => import("./pages/SystemSettings.vue"),
                meta: { title: "settings.system" },
            },
            {
                path: "loans/reasons",
                name: "settings-loan-reasons",
                component: () => import("./pages/LoanReasonsSettings.vue"),
                meta: { title: "settings.loan_reasons" },
            },
            {
                path: "reproductions/tariffs",
                name: "settings-reproduction-tariffs",
                component: () => import("./pages/ReproductionTariffsSettings.vue"),
                meta: { title: "settings.reproduction_tariffs" },
            },
            {
                path: "publications/tariffs",
                name: "settings-publication-tariffs",
                component: () => import("./pages/PublicationTariffsSettings.vue"),
                meta: { title: "settings.publication_tariffs" },
            }
        ]
    }
];
